import React from 'react'
import { IconTools } from '@tabler/icons-react'

import bannerGo from '../../static/img/banner_go.png'

import './styles/helped.css'

function Helped() {

    return (

        <section className='--helped'>

            <div className='--tit'>
                <h2>
                    <span>Conectamos talento con empresas </span>
                    <span>hacia un futuro mejor</span>
                </h2>
                <p>Nos esforzamos por crear una comunidad en crecimiento</p>
            </div>

            <div className='--bg-cards'>

                <div className='--flex-cards'>
                    <div className='--card-w --card-w-A'>
                        <div className='--card-w-h'>
                            <div className='--ico'><IconTools/></div>
                        </div>
                        <div className='--card-w-b'>
                            <p>Conectando individuos talentosos con empresas para gestar un futuro más próspero y brillante.</p>
                        </div>
                    </div>
                    <div className='--card-w --card-w-B'>
                        <div className='--card-w-h'>
                            <div className='--ico'><IconTools/></div>
                        </div>
                        <div className='--card-w-b'>
                            <p>Facilitando el contacto entre talento excepcional y empresas en pos de un futuro más prometedor y sólido.</p>
                        </div>
                    </div>
                    <div className='--card-w --card-w-C'>
                        <div className='--card-w-h'>
                            <div className='--ico'><IconTools/></div>
                        </div>
                        <div className='--card-w-b'>
                            <p>Estableciendo vínculos entre talento cualificado y empresas en aras de construir un futuro mejor.</p>
                        </div>
                    </div>
                </div>

                <div className='--figure'>
                    <img src={bannerGo} alt='' />
                </div>

            </div>

        </section>

    )

}

export default Helped